export default __webpack_public_path__ + "static/media/logo.fc69c03c.svg";